import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

AppointmentsDate.propTypes = {
    date: PropTypes.string,
    entry: PropTypes.object,
    onSelectDate: PropTypes.func,
    selectedDate: PropTypes.string
};

export default function AppointmentsDate({
    date = null,
    entry = null,
    onSelectDate = () => {},
    selectedDate = null
}) {
    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]

    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]

    function formatDate(date) {
        const d = new Date(date);
        let nth = 'th';
        if (d.getDate() === 1 || d.getDate() === 21 || d.getDate() === 31) {
            nth = 'st';
        } else if (d.getDate() === 2 || d.getDate() === 22) {
            nth = 'nd';
        } else if (d.getDate() === 3 || d.getDate() === 23) {
            nth = 'rd';
        }
        return days[d.getDay()]+' '+d.getDate()+nth+' '+months[d.getMonth()]+' '+d.getFullYear();
    }

    function handleDateSelect(entry) {
        document.dispatchEvent(new CustomEvent('select-date', {detail: JSON.stringify(entry)}));
        onSelectDate(entry);
    }

    return (
        <div className="appointmentDate">
            <p className="appointmentDate__title">{formatDate(date)}</p>
            <ul className="appointmentDate__list">
                {Object.keys(entry).map((key) => ({
                    id: key,
                    ...entry[key]
                })).map(entry => (
                    <li key={entry.id} onClick={() => handleDateSelect(entry)} className={`appointmentDate__button ${selectedDate && selectedDate.id == entry.id && selectedDate.date == entry.date ? 'appointmentDate__button--selected' : ''}`}>{entry.date.substring(11,16)}</li>
                ))}
            </ul>
        </div>
    );
}